import { render, staticRenderFns } from "./jiating.vue?vue&type=template&id=cc99a41c&scoped=true&"
import script from "./jiating.vue?vue&type=script&lang=js&"
export * from "./jiating.vue?vue&type=script&lang=js&"
import style0 from "./jiating.vue?vue&type=style&index=0&id=cc99a41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc99a41c",
  null
  
)

export default component.exports